import React from "react";
import PictureGrid from "../components/PictureGrid";
import galleryImages from './gallery.json'
import { motion } from "framer-motion";

export default function Home() {

  return (
    <div style={{ width: "100%", overflowX: "hidden" }}>
      {/* Fullscreen Hero Section */}
      {/* <div
        style={{
          height: "100vh",
          width: "100%",
          backgroundImage:
            "url('/images/gallery/1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      /> */}

      {/* Fullscreen Hero Section */}
      <div
        style={{
          position: "relative",
          height: "100vh",
          width: "100%",
          backgroundImage: "url('images/gallery/1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.45)",
            backdropFilter: "blur(2px)",
          }}
        />

        {/* Animated Text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          style={{
            position: "relative",
            textAlign: "center",
            color: "white",
            padding: "0 20px",
          }}
        >
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 1 }}
            style={{
              fontSize: "3rem",
              fontWeight: 700,
              marginBottom: "12px",
              textShadow: "0 4px 18px rgba(0,0,0,0.5)",
            }}
          >
            Hall of Residence 11
          </motion.h1>

          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 1 }}
            style={{
              fontSize: "1.5rem",
              fontWeight: 400,
              opacity: 0.95,
              textShadow: "0 3px 12px rgba(0,0,0,0.4)",
            }}
          >
            The Crown of IIT Kanpur
          </motion.h3>
        </motion.div>
      </div>



      {/* Description Section */}
      <div
        style={{
          maxWidth: "900px",
          margin: "4rem auto",
          padding: "0 20px",
          fontSize: "1.05rem",
          lineHeight: 1.7,
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "3rem",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Welcome to Hall of Residence XI
        </h2>

        <p><strong>Hall of Residence 11</strong>, Indian Institute of Technology Kanpur, is a vibrant residential community that brings together students from diverse backgrounds, disciplines, and cultures.</p>

        <p>More than just a place to stay, Hall 11 is a space where academic rigor meets camaraderie, leadership, and lifelong friendships.</p>

        <p>Rooted in the values of mutual respect, inclusivity, and excellence, the hall fosters an environment that encourages personal growth beyond classrooms—through cultural activities, sports, technical initiatives, and community living.</p>

        <p>At Hall 11, residents grow not only as scholars, but as responsible individuals ready to contribute meaningfully to the institute and to society.</p>

      </div>

      {/* Gallery Section */}
      <h2
        style={{
          textAlign: "center",
          marginTop: "3rem",
          fontSize: "1.8rem",
          fontWeight: 600,
          marginBottom: "3rem"
        }}
      >
        A Few Glimpses
      </h2>

      <PictureGrid images={galleryImages} />
    </div>
  );
}
